import { useState, useCallback } from 'react';
import quarkusApi from '../../../../api/quarkusApi';

const authHeader = () => ({ headers: { Authorization: sessionStorage.getItem('token') } });

export function useAestheticProtocolActions(patientId) {
  const [isLoading, setLoading] = useState(false);

  const base = `/patients/${patientId}/aesthetic-protocols`;

  const generateCharge = useCallback(
    (protocolId) => {
      setLoading(true);
      return quarkusApi
        .get(`${base}/${protocolId}/generate-charge`, authHeader())
        .finally(() => setLoading(false));
    },
    [base],
  );

  const start = useCallback(
    (protocolId) => {
      setLoading(true);
      return quarkusApi
        .post(`${base}/${protocolId}/start`, {}, authHeader())
        .finally(() => setLoading(false));
    },
    [base],
  );

  const remove = useCallback(
    (protocolId) => {
      setLoading(true);
      return quarkusApi
        .delete(`${base}/${protocolId}`, authHeader())
        .finally(() => setLoading(false));
    },
    [base],
  );

  return { generateCharge, start, remove, isLoading };
}
